// Generated by CoffeeScript 1.12.7
var getPath, normalize;

getPath = require('./get-path');

normalize = require('path').normalize;

module.exports = function(findPath, findMoule) {
  var getModulePaths, isLocal;
  isLocal = function(path) {
    return path[0] === '.';
  };
  return getModulePaths = function(base, conf, childCallers) {
    var modules, out, parentConfigs;
    if (childCallers == null) {
      childCallers = [];
    }
    modules = conf.modules;
    parentConfigs = conf.parents || [];
    out = [];
    parentConfigs.forEach(function(p) {
      var callers, parentConf, parentConfPath;
      callers = childCallers.concat(p.nodeModule);
      parentConf = findMoule(base, p.configFile, callers);
      parentConfPath = findPath(base, p.configFile, callers);
      out.push({
        isConfig: true,
        isLocal: true,
        path: normalize(parentConfPath)
      });
      return out = out.concat(getModulePaths(base, parentConf, callers));
    });
    Object.keys(modules).map(function(key) {
      var fullPath, mod, registeredPath;
      mod = modules[key];
      registeredPath = getPath(mod);
      fullPath = normalize(findPath(base, registeredPath, childCallers));
      return out.push({
        key: key,
        path: fullPath,
        registeredPath: registeredPath,
        isLocal: isLocal(registeredPath),
        module: mod
      });
    });
    return out;
  };
};
